const documentTypes = ["agreement", "product", "other"];

export default documentTypes;
